import React from 'react';

const MOBILE_DOT_COUNT = 3;
const DESKTOP_DOT_COUNT = 5;


const DESKTOP_CONNECTOR_HEIGHT = 480;

export default function SolveFlowConnector({ loading /*, anchorHeight */ }) {
  const getInitialDotCount = () => {
    if (typeof window === 'undefined') {
      return MOBILE_DOT_COUNT;
    }

    return window.matchMedia('(min-width: 1024px)').matches
      ? DESKTOP_DOT_COUNT
      : MOBILE_DOT_COUNT;
  };

  const [dotCount, setDotCount] = React.useState(getInitialDotCount);

  React.useEffect(() => {
    if (typeof window === 'undefined') {
      return undefined;
    }

    const mediaQuery = window.matchMedia('(min-width: 1024px)');

    const handleChange = (event) => {
      setDotCount(event.matches ? DESKTOP_DOT_COUNT : MOBILE_DOT_COUNT);
    };

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', handleChange);
      return () => mediaQuery.removeEventListener('change', handleChange);
    }

    mediaQuery.addListener(handleChange);
    return () => mediaQuery.removeListener(handleChange);
  }, []);

  const dots = React.useMemo(() => new Array(dotCount).fill(null), [dotCount]);
  const isDesktop = dotCount === DESKTOP_DOT_COUNT;

  const verticalStyle = isDesktop
    ? { height: `${DESKTOP_CONNECTOR_HEIGHT}px` }
    : undefined;

  return (
    <div className="flex w-full items-center justify-center lg:w-auto lg:self-start">
      {/* keep your original flex/center, but now inside a fixed-height box */}
      <div className="flex flex-col justify-center" style={verticalStyle}>
        <div className="solve-flow-dots-wrapper">
          {dots.map((_, index) => (
            <span
              key={index}
              className={
                loading ? 'solve-flow-dot solve-flow-dot--loading' : 'solve-flow-dot'
              }
              style={loading ? { animationDelay: `${index * 0.18}s` } : undefined}
              aria-hidden="true"
            />
          ))}
        </div>
      </div>
    </div>
  );
}
